// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.google-ads-ads-table-panel.dashboard-data-table-panel .dashboard-data-table-panel__header {
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
}

.google-ads-ads-table-panel .paid-media-table-toolbar {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  flex: 0 1 auto;
  width: auto;
  min-width: 0;
  margin-inline-start: auto;
}

.google-ads-ads-table-panel .paid-media-table-toolbar__search,
.google-ads-ads-table-panel .dashboard-data-table-panel__search {
  display: inline-flex;
  flex: 0 1 auto;
  width: 280px;
  min-width: 200px;
  max-width: 280px;
  margin-inline-start: 0;
}

.google-ads-ads-table-panel .paid-media-export-btn {
  flex: 0 0 auto;
  white-space: nowrap;
}

@media (max-width: 768px) {
  .google-ads-ads-table-panel.dashboard-data-table-panel .dashboard-data-table-panel__header {
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
  }
  .google-ads-ads-table-panel .paid-media-table-toolbar {
    flex-wrap: nowrap;
    width: auto;
  }
  .google-ads-ads-table-panel .paid-media-table-toolbar__search,
  .google-ads-ads-table-panel .dashboard-data-table-panel__search {
    width: auto;
    min-width: 180px;
    max-width: 240px;
  }
}`, "",{"version":3,"sources":["webpack://./src/dashboards/paidMedia/components/googleAds/GoogleAdsTable.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,8BAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;AACF;;AAEA;;EAEE,oBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;AACF;;AAEA;EACE,cAAA;EACA,mBAAA;AACF;;AAEA;EACE;IACE,mBAAA;IACA,iBAAA;IACA,mBAAA;EACF;EAEA;IACE,iBAAA;IACA,WAAA;EAAF;EAGA;;IAEE,WAAA;IACA,gBAAA;IACA,gBAAA;EADF;AACF","sourcesContent":[".google-ads-ads-table-panel.dashboard-data-table-panel .dashboard-data-table-panel__header {\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.google-ads-ads-table-panel .paid-media-table-toolbar {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  flex: 0 1 auto;\n  width: auto;\n  min-width: 0;\n  margin-inline-start: auto;\n}\n\n.google-ads-ads-table-panel .paid-media-table-toolbar__search,\n.google-ads-ads-table-panel .dashboard-data-table-panel__search {\n  display: inline-flex;\n  flex: 0 1 auto;\n  width: 280px;\n  min-width: 200px;\n  max-width: 280px;\n  margin-inline-start: 0;\n}\n\n.google-ads-ads-table-panel .paid-media-export-btn {\n  flex: 0 0 auto;\n  white-space: nowrap;\n}\n\n@media (max-width: 768px) {\n  .google-ads-ads-table-panel.dashboard-data-table-panel .dashboard-data-table-panel__header {\n    flex-direction: row;\n    flex-wrap: nowrap;\n    align-items: center;\n  }\n\n  .google-ads-ads-table-panel .paid-media-table-toolbar {\n    flex-wrap: nowrap;\n    width: auto;\n  }\n\n  .google-ads-ads-table-panel .paid-media-table-toolbar__search,\n  .google-ads-ads-table-panel .dashboard-data-table-panel__search {\n    width: auto;\n    min-width: 180px;\n    max-width: 240px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
